import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'
import uploadJSON from '@/components/UploadJSON'
import TheHome from '@/components/TheHome'
import EditSnps from '@/components/EditSnps'
import UploadImage from '@/components/UploadImage'
import firebase from 'firebase'

Vue.use(VueRouter)

const router = new VueRouter({
    name: 'router',
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'Login',
        component: Login
      },
    {
        path: '/upload-json',
        name: 'UploadJson',
        component: uploadJSON,
        meta: { requiresAuth: true }
    },
    {
        path: '/home',
        name: 'TheHome',
        component: TheHome,
        meta: { requiresAuth: true }
      },
      {
        path: '/edit-snps',
        name: 'EditSnps',
        component: EditSnps,
        meta: { requiresAuth: true }
      },
      {
        path: '/upload-image',
        name: 'UploadImage',
        component: UploadImage,
        meta: { requiresAuth: true }
      }],
});

// Route guarding
router.beforeEach((to, from, next) => {
	if (to.matched.some(rec => rec.meta.requiresAuth)){
        firebase.auth().onAuthStateChanged(user => {
              if (user) {
                next()
              } else {
                next({name: 'Login'})
              }
            })
	}
    else {
		next()
	}
})

export default router;